import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FilterRequestEvaluated } from '../shared/filter-request-evaluated.model';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from 'src/app/core/modal/confirmation-dialog/confirmation-dialog.component';
import { Role } from '../../requets/shared/model/Role.model';
import { BossDependence } from '../../requets/shared/model/boss-dependence.model';
import { UtilityService } from 'src/app/core/shared/utility.service';

@Component({
  selector: 'app-search-fields-state',
  templateUrl: './search-fields-state.component.html',
  styleUrls: ['./search-fields-state.component.scss']
})
export class SearchFieldsStateComponent implements OnInit {

  cedula: string;
  selectedType: String = 'MATERIA REGULAR';

  enabledSpinner = false;
  enabledType = false;
  enabledMateriaRegular = false;
  filterRequest: FilterRequestEvaluated;
  messageError: String = '';
  claseMessage: String = 'messaje-error';

  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();
  @Input() roles: Role[] = [];
  @Input() typeValidation: number;
  @Input() bossDeependence: BossDependence;
  @Input() currentRol: Role;

  constructor(private dialog: MatDialog, private utilityService: UtilityService) { }



  ngOnInit() {
    this.setDataAsistete();
  }

  sendSearchParam() {
    if (this.cedula !== undefined && this.cedula !== '' ) {
      if (this.selectedType !== undefined && this.selectedType !== '' ) {
        this.filterRequest = new FilterRequestEvaluated();
        this.filterRequest.cedula = !this.cedula ? null : this.cedula;
        this.filterRequest.tipo = !this.selectedType ? null : this.selectedType;
        this.messageError = '';
        this.sendSearchRequest.emit(this.filterRequest);
      } else {
        this.messageError = 'Seleccionar el tipo de solcitud';
      }
    } else {
      this.messageError = 'Ingresar la identificación del estudiante';
    }
  }


  clean() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      tittle: 'Mensaje Confirmación',
      message:
        '¿Esta seguro que desea limpiar los filtros?'
    };
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig );
    dialogRef.afterClosed().subscribe(value => {
      if (value === 1) {
        this.filterRequest = new FilterRequestEvaluated();
        this.cedula = '';
      }
    });
  }

  private setDataAsistete() {
    if (this.typeValidation > 0) {
      if (this.typeValidation === 2) {
        this.enabledType = true;
      }
      if (this.roles.length > 1) {
        this.enabledMateriaRegular = true;
      } else {
        this.enabledMateriaRegular = false;
      }
      if (this.currentRol.rol === this.utilityService.rolAistenciaIdiomas) {
        this.selectedType = 'MATERIA LENGUA EXTRANJERA';
      }
    } else {
      // renviar de que el usuario no tiene un rol valido
    }
  }

}
